<template>
    <div class="row">
        <div v-for="(val,key) in list" :key="key" :class="{'last-col-device' : (key == 2), 'hidden-device': (key == 3) }" class="col col-xs-12 col-md-3">
            <div class="thumbnail vdo alignment">
                <div class="wrap">
                    <a class="image" :href="val.url">
                        <img v-lazy="'http://i.ytimg.com/vi/'+ val.id +'/hqdefault.jpg'" alt="">
                        <span class="time"><i class="ic ic-clock-o"></i><span class="ic-name">{{ val.duration }}</span></span>
                        <span class="play"><i class="ic ic-play"></i></span>
                    </a>
                    <div class="meta">
                        <!-- <h3 class="title"><a :href="val.url">{{ val.title }}</a></h3> -->
                        <TagDotDotDot :url="val.url" :text="val.title" :tag="'h3'" :customClass="'title'" />
                        <div class="info"><div class="counting"><YoutubeView :youtube_id="val.id" /> &nbsp;&#8226;&nbsp; <timeago :datetime="val.createdate"></timeago></div></div>
                        <div class="category"><strong>{{ getVideoTagName( val.video_tag ) }}</strong></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VueTimeago from 'vue-timeago'

import VueLazyload from 'vue-lazyload'

import YoutubeView from '@/components/parts/YoutubeView.vue'
import TagDotDotDot from '@/components/parts/TagWithDotDotDot.vue'

import { VideoTag } from '@/library/GlobalHelper.js'
Vue.use(VueLazyload)

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en'
})

export default {
  name: 'VideoHome',
  components: {
    YoutubeView, TagDotDotDot
  },
  data () {
    return {
      list: window._video
    }
  },
  methods: {
    getVideoTagName (valueKey) {
      let arr = VideoTag()
      var result = arr.filter((item) => {
        return item.key === valueKey
      })
      return typeof result[0] !== 'undefined' ? result[0].name : ''
    }
  }
}
</script>
